
export default {
  routeImporter: {
    loadRouteFile: 'Datei importieren',
    failedToLoadFile: 'Datei konnte nicht geladen werden. Failed to load file selected. Stellen Sie sicher, dass die Datei nicht beschädigt ist und ein gültiges Format hat',
    acceptedImportTypes: 'Mögliche Formate',
    dictDefaultMessage: 'Datei mit Route hier ablegen oder hier klicken',
    dictFallbackMessage: 'Browser nicht unterstützt',
    dictFileTooBig: 'Datei zu groß',
    dictInvalidFileType: 'Ungültiges Dateiformat',
    dictCancelUpload: 'Upload abbrechen',
    dictUploadCanceled: 'Upload abgebrochen',
    dictRemoveFile: 'Datei Löschen'
  }
}
